
//import {Later} from 'utils/timers'
import FeedHeader from './feed-header.vue'
import PulseActions from '../pulse-actions.vue'
import {SourcesSection} from 'components/sources-v2'

export default {
  components: {
    FeedHeader,
    SourcesSection,
    PulseActions
  },
  props: {
    item: {type: Object, required: true},
    active: {type: Boolean, default: false},
    static: {type: Boolean, default: false},
  },
  data() {
    return {
      user_hover: false,
      opened_popups: new Set(),
    }
  },
  computed: {
    active_state(){
      return this.active || !!this.opened_popups.size
    },
  },
  methods: {
    onMouseEnter() {
      if (this.static) {
        return
      }
      this.user_hover = true
    },
    onMouseLeave() {
      if (this.static) {
        return
      }
      this.user_hover = false
    },
    handleFeedback(ev){
      // we track the opening/closing of two pop-up windows to avoid unwanted hiding of the action bar
      ev.show ? this.opened_popups.add(ev.id) : this.opened_popups.delete(ev.id) 
    },
    async onClick() {
      if (this.static) {
        return
      }
    }
  }
}
